import { useContext } from 'react';
import { RepeatChartRefContext, ConjointAnalysisAttributeColorsContext } from '@containers/RepeatSurveyResponses/Context';

export const useRepeatChartRef = () => useContext(RepeatChartRefContext);
export const useConjointAnalysisAttributeColors = () => useContext(ConjointAnalysisAttributeColorsContext);